/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateControlProperty } from '../../actions/report-designer.actions';
import { REPORT_MODEL_ATTRIBUTES } from '../../constants/report-designer.constants';
import { getControlProperty } from '../../selectors/report-designer.selectors';
import ExpressionModal from '../ExpressionModal';

const useStyles = makeStyles({
  modal: {
    minWidth: '80%',
  },
});

const PropertyModal = ({ controlId, name, label, onClose }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const controlType = useSelector((state) =>
    getControlProperty(state, { id: controlId, prop: REPORT_MODEL_ATTRIBUTES.CONTROL_TYPE })
  );
  const propValueStore = useSelector((state) =>
    getControlProperty(state, { id: controlId, prop: name })
  );

  const modalTitle = `Expression Editor (${controlType} - ${label})`;
  const propValueTemp = _.isString(propValueStore)
    ? propValueStore.replace(/eval\|\|/g, '')
    : _.isBoolean(propValueStore)
    ? propValueStore
    : '';

  const [expressionValue, setExpressionValue] = useState(propValueTemp);

  const buttonsList = [
    {
      label: 'Cancel',
      onClick: onClose,
      'ui-ta': 'CancelBtn',
    },
    { label: 'Save', onClick: () => saveChanges({ expressionValue }), 'ui-ta': 'SaveBtn' },
  ];

  const saveChanges = ({ expressionValue } = {}) => {
    if (propValueStore !== expressionValue) {
      const storeParsedValue =
        expressionValue && !expressionValue.includes('eval||')
          ? `eval||${expressionValue}`
          : expressionValue;

      dispatch(updateControlProperty(controlId, name, storeParsedValue));
    }
    onClose();
  };

  const updateExpressionTextFieldFromOutside = (updateValue) => {
    const updatedValue = updateValue(expressionValue);
    setExpressionValue(updatedValue);
  };

  const updateExpression = ({ target }) => {
    setExpressionValue(target.value);
  };

  return (
    <Modal
      open
      variant="default"
      className={classes.modal}
      onClose={onClose}
      title={modalTitle}
      buttonProps={buttonsList}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <ExpressionModal
        onChange={updateExpressionTextFieldFromOutside}
        expression={expressionValue}
        onBlurEditor={updateExpression}
      />
    </Modal>
  );
};

export default PropertyModal;
